export const parseCardNumber = (cardNumber) => {
    const result = cardNumber.replace(/\D/g, '');
    return result;
};
//# sourceMappingURL=parse-card-number.js.map